import { ADD_USERS_COURSE_PAGE_KEY } from '../constants';

const es = {
  [ADD_USERS_COURSE_PAGE_KEY]: {
    TITLE_ADD_USER_COURSES: 'Asignación de usuarios',
    BACK_LABEL: 'Volver',
    TITLE_TABLE: 'Selecciona los usuarios que quieres asignar a tu curso:',
    COURSE_LABEL: 'Curso',
    LOADING_TITLE: 'Asignando usuarios...',
    LOADING_DESCRIPTION: 'Terminaremos en breve, gracias por tu espera',
    ROLE_ALL: 'Todos',
    ROLE_ADMIN: 'Administrador',
    ROLE_USER: 'Usuario',
    TITLE: 'Usuarios',
    SEARCH: 'Buscar',
    SELECT_USER_ALL: 'Usuarios seleccionados en total.',
    SELECT_USER: 'Usuario seleccionados de esta página.',
    SELECT_USER_plural: 'Usuarios seleccionados de esta página.',
    SELECT_USER_ALL_LABEL: 'Seleccionar los {{totalUser}} usuarios',
    COLUMN_NAME: 'Nombre',
    COLUMN_EMAIL: 'Correo',
    COLUMN_REGISTER: 'Nº REGISTROS',
    COLUMN_USER: 'Usuario',
    COLUMN_UPLOAD_DATE: 'Fecha de importación',
    COLUMN_DETAIL_ERROR: 'Detalle de errores',
    COLUMN_ROLE: 'Tipo',
    COLUMN_TAGS: 'Etiquetas',
    COLUMN_STATUS: 'Estado',
    SUCCES_ASSIGN: 'Se asignaron *{{count}}* usuario al curso correctamente.',
    SUCCES_ASSIGN_plural:
      'Se asignaron *{{count}}* usuarios al curso correctamente.',
    SUCCES_SUBTITLE: 'Estos usuarios ahora podrán disfrutar del curso.',
    SUCCESS_DESCRIPTION:
      'Ahora puedes acceder al detalle de la sesión para obtener más información.',
    SUCCESS_DESCRIPTION_ASYNC:
      '**El proceso puede tardar más de lo esperado.** Te avisaremos por correo al finalizar.',
    SUCCES_ASSIGN_ASYNC: 'Se están asignando  a *{{count}}* usuarios al curso.',
    SUCCES_ASSIGN_ASYNC_SUBTITLE:
      'No te preocupes! te enviaremos un correo informando cuando tus usuarios hayan sido asignados correctamente al curso.',
    BTN_ACTION: 'Asignar usuarios',
    BTN_ACTION_MANUAL: 'Asignar usuarios',
    BTN_ACTION_SEGMENTATION: 'Asignar usuarios por segmentación',
    BTN_CANCEL: 'Cancelar',
    MODAL_SEGMENTATION_TITLE: 'Gestión de atributos',
    MODAL_SEGMENTATION_DESCRIPTION:
      'Los atributos seleccionados determinan qué usuarios podrán visualizar el contenido de la categoría seleccionada.',
    MODAL_CONFIRM_TITLE: 'Confirmar asignación de usuarios',
    MODAL_CONFIRM_DESCRIPTION:
      'Revisa los usuarios seleccionados antes de continuar',
    MODAL_CONFIRM_MANUAL_USERS: 'Usuarios seleccionados manualmente',
    MODAL_CONFIRM_SEGMENT_USERS: 'Usuarios del segmento',
    MODAL_CONFIRM_NO_USERS: 'No hay usuarios en este grupo',
    MODAL_CONFIRM_USER_COUNT: '{{count}} usuario',
    MODAL_CONFIRM_USER_COUNT_plural: '{{count}} usuarios',
    MODAL_CONFIRM_NO_NAME: 'Sin nombre',
    MODAL_CONFIRM_NO_EMAIL: 'Sin email',
    MODAL_SAVE_BTN: 'Guardar',
    MODAL_CANCEL_BTN: 'Cancelar',
    ERROR_TITLE: 'Ocurrió un error inesperado',
    ERROR_SUBTITLE: 'Por favor, vuelve a intentarlo nuevamente.',
    ERROR_BTN: 'Entiendo',
    BTN_LABEL: 'Entendido',
    SELECT_CATEGORY: 'Seleccionar una categoría',
    SELECT_EMPTY: 'No se han encontrado resultados',
    SELECT_EMPTY_SUBTITLE: 'Prueba palabras clave más generales',
    STATUS_ACTIVE: 'Activo',
    STATUS_PENDING: 'Pendiente',
    TAB_TITLE: '¿Cómo quieres agregar los usuarios al curso?',
    TAB_SUBTITLE: 'Elige la opción de tu preferencia para asignar usuarios.',
    TAB_MANUAL: 'Manualmente',
    TAB_MASSIVE: 'Masivamente',

    MASSIVE_FIRST_STEP: 'Utiliza la plantilla en Excel',
    MASSIVE_FIRST_STEP_DOWNLOAD_TEMPLATE: 'Descargar plantilla',
    MASSIVE_SECOND_STEP: 'Ingresa el correo electrónico de tu usuarios.',
    MASSIVE_THIRD_STEP: 'Sube el archivo de Excel y \ndale a “Siguiente”.',
    STEP_2_TITLE: 'Validar datos',
    STEP_2_ERROR_TITLE: 'Error en la validación de datos',
    STEP_2_VALIDATION_ERROR: 'Ver detalle de error',
    STEP_2_POPPER_ERROR_2_TITLE: 'Registros no encontrados',
    STEP_2_POPPER_ERROR_2_SUBTITLE:
      'Verifica que la plantilla que deseas subir no esté vacía, cada registro debe tener el dato del correo electrónico.',
    STEP_2_POPPER_ERROR_2_BUTTON: 'Volver a cargar el archivo',
    STEP_2_TABLE_TITLE: 'Validando data de usuarios...',
    STEP_2_VALIDATION_TITLE: 'Evaluando los requisitos:',
    STEP_2_VALIDATION_1: 'Validando cabecera de archivo',
    STEP_2_VALIDATION_2: 'Comprobando la cantidad de usuarios a asignar',
    STEP_2_VALIDATION_3: 'Verificando los correos electrónicos',
    STEP_2_POPPER_ERROR_3_TITLE: 'Plantilla incorrecta',
    STEP_2_POPPER_ERROR_3_SUBTITLE:
      'Te recomendamos descargar la plantilla sugerida. Después de llenarla correctamente, podrás regresar y cargarla nuevamente.',
    STEP_2_POPPER_ERROR_3_BUTTON: 'Descargar plantilla',
    STEP_2_POPPER_ERROR_1_TITLE: 'Ocurrió un error inesperado',
    STEP_2_POPPER_ERROR_1_SUBTITLE:
      'Parece que hubo un problema al momento de cargar tu archivo, por favor vuelve a intentarlo',
    STEP_2_POPPER_ERROR_1_BUTTON: 'Volver a intentarlo',

    MASSIVE_STEP_UP: 'Subir archivo',
    MASSIVE_STEP_VALIDATION: 'Validar data',
    MASSIVE_STEP_DETAIL: 'Detalles de validación',
    MASSIVE_HEADER_DOWNLOAD: 'Descargar plantilla',
    MASSIVE_HEADER_FILE: 'Ingresa el correo electrónico de tu usuarios.',
    MASSIVE_HEADER_NEXT: 'Sube el **archivo de Excel** y dale a “Siguiente”.',
    MASSIVE_HEADER_DOWNLOAD_TITLE: 'Utiliza la plantilla de Excel',
    MASSIVE_ERROR_STEP_1: 'Formato inválido.',
    MASSIVE_ERROR_STEP_1_REPLACE: 'Cargar otro archivo',
    MASSIVE_ERROR_STEP_1_SUBTITLE:
      'Asegúrate de que el archivo tenga un formato válido, como .xlsx o .csv. ',
    MASSIVE_STEP_1_TITLE: 'Selecciona tu archivo',
    MASSIVE_STEP_1_SUBTITLE:
      'O arrastra y suelta el archivo .xlsx para cargarlo',
    MASSIVE_STEP_1_SIZE: 'Peso máx. 500kb',
    MASSIVE_STEP_1_IMPORTATION: 'Importaciones pasadas',
    MASSIVE_STEP_2_DETAIL:
      'Descarga el detalle de errores para que puedas corregirlos y volver a subir el archivo. O si deseas, puedes continuar con la subida de solo los usuarios validados correctamente.',
    MASSIVE_STEP_2_TITLE: 'Validando datos',
    MASSIVE_STEP_2_SUBTITLE: 'Validando la data de los usuarios...',
    MASSIVE_STEP_2_EVALUATION: 'Evaluando los requisitos',
    STEP_NEXT: 'Siguiente',
    STEP_FINISHED: 'Agregar usuarios',
    MASSIVE_STEP_3_SUCCESS: 'Correos electrónicos validados correctamente',
    MASSIVE_STEP_3_SUCCESS_NOTE:
      'Hemos detectado correos electrónicos duplicados, los cuales serán fusionados para garantizar que sean considerados una sola vez en el curso.',
    MASSIVE_STEP_3_WARNING:
      'Correo electrónicos registrados previamente en el curso',
    MASSIVE_STEP_3_WARNING_NOTE:
      'Hemos identificado correos electrónicos que ya están registrados en este curso. Estos correos no serán asignados nuevamente.',
    MASSIVE_STEP_3_ERROR: 'Correos electrónicos con errores',
    MASSIVE_STEP_3_ERROR_NOTE:
      'Al continuar con la validación estos usuarios no se agregarán en el curso.',
    MASSIVE_STEP_3_ERROR_NO_EMAIL:
      'Correos electrónicos sin registrar en tu organización',
    MASSIVE_STEP_3_ERROR_FORMAT_EMAIL:
      'Correos electrónicos con formato inválido',
    MASSIVE_STEP_3_ERROR_DISABLED_EMAIL:
      'Correos de usuarios eliminados o inactivos',
    MASSIVE_STEP_3_ERROR_DOWNLOAD: 'Descargar errores',
    MASSIVE_FINISHED_TITLE:
      'Se están agregando  a *{{count}}* usuarios al curso',
    MASSIVE_FINISHED_DESCRIPTION:
      'Este proceso puede tardar un poco más de lo esperado, serás notificado en cuanto el proceso haya finalizado.  ',
    ERROR:
      'Vuelve a intentar cargar el archivo. Si el problema persiste puedes intentarlo más tarde.',
    ERROR_SIZE_TITLE: 'Peso del archivo superado',
    ERROR_SIZE:
      'El archivo que intentaste agregar excede el peso máximo permitido de {{size}} MB.',
    ERROR_PERCENTAGE: 'Surgió un error',
    FILE_REEMPLACE_CUSTOM: 'Elige otro archivo',
    FILE_UPLOAD_CUSTOM: 'Subir archivo',
    FILE_DURATION_CUSTOM: '0 minutos',
    FILE_TIME: '{{progress}}% - {{duration}} para terminar',
    SWITCH_NOTIFICATION_NEW: '¡Nuevo!',
    SWITCH_NOTIFICATION_TITLE: 'Enviar correo a los colaboradores',
    SWITCH_NOTIFICATION_MESSAGE:
      ' Sirve para notificar a tus asignados sobre su nueva ruta. Si solicitaste no recibir correos, no se enviarán aunque esté activa la opción.',
    SWITCH_NOTIFICATION_DIALOG_TITLE_plural: 'Se enviarán *{{count}}* correos',
    SWITCH_NOTIFICATION_DIALOG_TITLE: 'Se enviarán *{{count}}* correo',
    SWITCH_NOTIFICATION_DIALOG_1:
      'Has activado la opción para **enviar un correo notificando la asignación de la ruta a los colaboradores** seleccionados.',
    SWITCH_NOTIFICATION_DIALOG_2:
      'Si prefieres no enviar los correos, desactiva esta opción en la parte superior de la tabla de usuarios.',

    SWITCH_NOTIFICATION_COURSES_MESSAGE:
      'Sirve para notificar a tus asignados sobre su nuevo curso. Si solicitaste no recibir correos, no se enviarán aunque esté activa la opción.',
    SWITCH_NOTIFICATION_DIALOG_COURSES_1:
      'Has activado la opción para **enviar un correo notificando la asignación del curso a los colaboradores** seleccionados.',
    SUCCESS_DESCRIPTION_COURSE:
      'Ahora puedes acceder al detalle del curso para obtener más información.',
    FILTER_HINT: 'Filtrar por',
  },
};

export default es;
